import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllTrainings() {
  return (
    <ModulePlaceholderList
      title="Training programs"
      newPath="/panel/trainings/new"
      newLabel="New training"
    />
  );
}
